import React, { useEffect, useState } from "react";
import clouds from "../assets/horizon-clouds.png";
import mountains from "../assets/horizon-mountains.png";
import underGround from "../assets/foreground-underground.png";
import eegGem4 from "../assets/eegg-gem4-dirty.png";
import eegHodl from "../assets/eegg-hodl.png";
import eegTama from "../assets/eegg-tamagochi1-dirty.png";
import eegWorm from "../assets/eegg-worm.png";
import gem6Dirty from "../assets/eegg-gem6-dirty.png";
import site from "../assets/Site_header_No_Mountains.png";
import siteM from "../assets/Site_header_No_Sky_.png";
import "../index.css";
import Header from "./Header";
const backgroundCloudGif= require('../assets/CP_Animated_Clouds.gif')
const backgroundCloudGifMin= require('../assets/CP_Animated_Clouds-min.gif')

function PageTop3() {
  const [offsetY, setOffsetY] = useState(0);
  const handleScroll = () => setOffsetY(window.pageYOffset);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    console.log(offsetY);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [offsetY]);
  return (
    <div 
    // style={{backgroundImage:`url(${backgroundCloudGif})`}} 
     className="PageTop cloudsGif  min-w-full max-w-full sm:min-h-[200px]  overflow-x-clip mb-0 w-full ">
      <Header />
      {/* <img src={backgroundCloudGif} className=' absolute top-0 w-full h-full z-0 object-cover '  alt="" /> */}
     <div className="max-h-[65vh] xs:max-h-[65vh] object-contain cloudsWrapper" >
     {/* <img className="relative z-0 opacity-0 cloudsBG " src={''} 
     alt="" /> */}

<div className=" mountainsSite fixed z-0  max-h-[100vh] ">
          {/* <img
            src={''}
            alt=""
            style={{
              height: offsetY > 10 ? 600 + "px" : "",
              transitionProperty: "height",
              maxHeight: "680px",
              objectFit: 'contain'
              // transform: `-translateY(${offsetY * 0.5}px)`
            }}
            className="transition mountainsBG ease g fixed  mountainsImg lg:w-screen"
          /> */}
        </div>

        <div className="site relative z-10 bottom-24 ">
        
        {/* <img src={site} alt="" className="relative z-10 top-[160px] w-full" /> */}
      </div>
     </div>
     <img src={siteM} alt="" className="relative z-10 bottom-[0px] w-full pt-40  sm:pt-16" />

     
      <div className="relative  ">
        <img src={underGround} className="mt-[0rem] z-50 w-[100vw]" alt="" />
        <img
          src={eegGem4}
          className="absolute top-3 w-10 left-24 z-40  -rotate-[70deg] lg:w-20"
          alt=""
        />
        <img
          src={eegHodl}
          className="absolute top-8 w-10 left-14 z-40  rotate-[10deg] lg:w-20 "
          alt=""
        />
        <img
          src={eegTama}
          className=" hidden md:display-block absolute top-5 w-10 left-[45.5rem] z-40  -rotate-[70deg] lg:w-20 "
          alt=""
        />
        <img
          src={eegWorm}
          className="absolute top-0 w-8 left-[50%] z-40 rotate-[25deg] lg:w-20"
          alt=""
        />
        <img
          src={gem6Dirty}
          className="absolute top-4 w-8 sm:w-16 left-[80%] z-40 rotate-[0deg]"
          alt=""
        />
      </div>
    </div>
  );
}

export default PageTop3;
